module.exports = "#define GLSLIFY 1\n#ifdef USE_MAP\n\n\tuniform sampler2D map;\n\n#endif\n"